<template>
  <div class="scoring-criterion">
    <div class="scoring-control">
      <scoring-control-select
        :score="1"
        :max-score="10"
        :min-score="1"
      ></scoring-control-select>
    </div>
  </div>
</template>

<script>
import ScoringControlSelect from '@/lib/components/ScoringCriteria/ScoringControlSelect';

export default {
  components: {
    ScoringControlSelect
  }
};
</script>
